/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_Feedback_DescInputs */



/**
* | output |
* | --- |
* | "After every conversation you see what went well and how to make it stronger." |
*
* @param {Onboarding_Pilot_How_Feedback_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_feedback_desc = /** @type {((inputs?: Onboarding_Pilot_How_Feedback_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_Feedback_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Na elk gesprek zie je wat goed ging en hoe je het sterker kan aanpakken.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Après chaque entretien, vous voyez ce qui a bien marché et comment l’aborder plus solidement.")
	return /** @type {LocalizedString} */ ("After every conversation you see what went well and how to make it stronger.")
});